import { AppAreaConfig } from '@/funnels/@types'
import { EU_REGION_COUNTRIES_REGEX } from '@/helpers/constants'

const appAreaConfig: AppAreaConfig = {
	appArea: 'activity-female-walking',
	options: {
		userFlags: ['hasAccessToWalkingVideos'],
		userTags: ['walking'],
	},
	landing: {
		ids: ['loader-walking-f', 'age-walking-f'],
		route: {
			path: '/walking-f',
			name: 'walking-funnel',
		},
		overrides: [
			// IS_BULK_CHANGES_WALKING_FEMALE_EXP web_bulk_change_walking_female
			{
				matcher: { country: 'us' },
				ids: ['loader-walking-f-us', 'age-walking-f-us'],
			},
			{
				matcher: {
					$or: {
						utm_content: /dategen/,
						utm_term: /dategen/,
					},
				},
				ids: ['creatives-dategen-female-walking', 'age-walking-f'],
			},
			{
				matcher: {
					lptype: 'female_funnel', // /walking-f?safe&lptype=female_funnel&lpid=
				},
				ids: ['dynamic-loader-female', 'dynamic-age-40-80'],
			},
		],
	},
	funnel: {
		id: 'ob-female-activity-walking',
		route: {
			path: '/walking-f/ob/:page(.*)?',
			// @ts-expect-error - Legacy: route.name не совпадает с appArea, будет исправлено позже
			name: 'female-activity-walking',
		},
		// @ts-expect-error - Legacy: slug не совпадает с appArea, будет исправлено позже
		slug: 'female-activity-walking',
		theme: 'light',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
	},
	prePaywall: {},
	paywall: {
		routeName: 'plan-walking-f',
		overrides: [
			{
				matcher: { country: 'us' },
				routeName: 'plan-walking-f-us',
			},
			{
				matcher: { country: EU_REGION_COUNTRIES_REGEX },
				routeName: 'plan-walking-f-eu',
			},
		],
	},
	upsell: {
		routeNames: ['upsell-activity-f'],
	},
	upgrade: {
		routeName: null,
	},
}

export default appAreaConfig
